import { useEffect, useState } from "react";
import { FaCheck, FaMinus, FaPlus } from "react-icons/fa6";
import {
  LANGUAGE_ENGLISH,
  LANGUAGE_JAPANESE,
} from "../../../../constants/common_constants";
import { useDtsAppContext } from "../../../../components/provider/DtsAppContextProvider";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface languageInfo {
  displayName: string;
  GraphValue: string;
}

export const SelectLanguageList: React.FC = () => {
  //言語切替処理用
  const { i18n, t } = useTranslation();
  //ページ遷移用
  const navigate = useNavigate();

  const { dacLanguage, setDacLanguage } = useDtsAppContext();
  const [open, setOpen] = useState<boolean>(false); // メニューが開いているかどうかを格納
  const [selectedLang, setSelectedLang] = useState<number>(0); // 開いたメニューの何番目の要素が選択されたかを格納
  const items: languageInfo[] = [
    { displayName: "English", GraphValue: LANGUAGE_ENGLISH },
    { displayName: "日本語", GraphValue: LANGUAGE_JAPANESE },
  ]; //TODO:多言語対応時に拡張, 現在(2024/10/30)日本語はテスト用なので本番では削除

  const language = dacLanguage || localStorage.getItem("language");

  //初回の処理(Context or localStorageに格納されている言語情報をもとに初期選択状態を変更)
  useEffect(() => {
    items.forEach((languageInfo, index) => {
      if (language === languageInfo.GraphValue) {
        return setSelectedLang(index);
      }
    });

    //言語切替
    if (language) {
      i18n.changeLanguage(language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  // 言語が選択された時の処理
  const handleOnLanguageItem = (languageInfo: languageInfo, index: number) => {
    setSelectedLang(index);
    //言語切替
    i18n.changeLanguage(languageInfo.GraphValue);
    setDacLanguage(languageInfo.GraphValue);
    localStorage.setItem("language", languageInfo.GraphValue);
    setOpen((prevState) => !prevState);
  };

  // 言語リスト(2階層目)をレンダリングする関数
  const renderLanguages = () => {
    return items.map((languageInfo, index) => (
      <dd
        className={`flex items-center cursor-pointer text-lg py-3 ${
          selectedLang === index ? "px-5" : "pl-12 pr-5"
        } 
        }`}
        onClick={() => handleOnLanguageItem(languageInfo, index)}
        key={languageInfo.GraphValue}
      >
        <div>{selectedLang === index && <FaCheck className="mr-2" />}</div>
        <p>{languageInfo.displayName}</p>
      </dd>
    ));
  };

  // 言語選択(1階層目)をレンダリングする関数
  const renderSelectLanguages = () => {
    return (
      <dt
        className={`flex justify-between items-center ${
          open && "border-b"
        }  border-gray-500 cursor-pointer py-3 px-5`}
        onClick={() => setOpen((prevState) => !prevState)}
      >
        <div>
          {t("トップ画面.言語選択")}
          {/* 言語選択 */}
        </div>
        <div>{open ? <FaMinus /> : <FaPlus />}</div>
      </dt>
    );
  };

  // 各リスト部分をレンダリングする関数
  const renderList = () => {
    return (
      <div className="w-full">
        {renderSelectLanguages()}
        {open && renderLanguages()}
      </div>
    );
  };

  return (
    <dl className={`flex w-full bg-white border-b border-gray-500 text-lg`}>
      {renderList()}
    </dl>
  );
};
